import { Injectable } from '@angular/core';
import { OPD_REPORT_TYPE } from '../regproperties/opd-report-properties';
import { opdNavigation } from '../regproperties/opd-navigation-properties';
import { OPD_CONST } from '../regproperties/opd-static-properties';

@Injectable({
  providedIn: 'root'
})
export class PatientLableService {

  constructor() { }
  generateReports(encounterId: string, reportname: string, isValue?: boolean) {
    let reqPayload = {
      transactionId: encounterId,
      type: OPD_REPORT_TYPE.pdf,
      reportName: reportname,
      parameterList: [{
        parameter: "isPrefixRequired",
        value: isValue? "true" : "false"
      }],
      isOPD: true
    };
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }

generateMultiReports(encounterId, reportname: string) {
  encounterId.forEach((id: string, index: number) => {
    const reqPayload = {
      transactionId: id,
      type: OPD_REPORT_TYPE.pdf,
      reportName: reportname,
      isReports: false,
      isAdt: true
    };

    const key = "adtPayload_" + id;
    localStorage.setItem(key, JSON.stringify(reqPayload));

    setTimeout(() => {
      window.open(`${opdNavigation.REPORT_NAVIGATE}2?Key=${key}`, "_blank");
     }, index * 500);
   });
  }

}
